import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.match";
import _classCallCheck from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * JSBridge 标准接口协议
 * @desc 各平台可继承此类，重写其中的方法
 * @class Protocol
 * @author colynchen
 */
import { invoke as _invoke, on as _on, off as _off } from './lib/tenvideo';
import cookie, { parse } from './util/cookie';
import env from './lib/env';
import { buildUrl } from './lib/url';
import { toast as _toast } from './lib/toast';
import Loading, { hideLoading as _hideLoading } from './lib/loading';
import { getMainUserInfo as _getMainUserInfo, getPayVip as _getPayVip } from './lib/service';
import { getVersion as _getVersion } from './lib/Version';
import { assign } from './util';
/**
 * JSBridge 基础类，实现所有共用接口
 * @class Protocol
 */

var Protocol = /*#__PURE__*/function () {
  function Protocol() {
    _classCallCheck(this, Protocol);

    this.EVENTS = {
      'login': 'onActionLoginFinish',
      'logout': 'onActionLogoutFinish'
    };
  }
  /**
   * 监听事件回调
   * @param {String} event - 事件名称
   * @param {Function} callback - 事件方法
   */


  _createClass(Protocol, [{
    key: "on",
    value: function on() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      // 找到对应的 Event listener
      if (this.EVENTS[event]) {
        event = this.EVENTS[event];
      }

      _on(event, callback);
    }
    /**
     * 监听事件回调，仅监听一次该事件
     * @param {String} event - 事件名称
     * @param {Function} callback - 事件方法
     */

  }, {
    key: "once",
    value: function once() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      _on(event, callback, true);
    }
    /**
     * 解除事件监听
     * @param {String} event - 事件名称
     * @param {Function} callback - 事件方法
     */

  }, {
    key: "off",
    value: function off() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      _off(event, callback);
    }
    /**
     * 提供给新增加的 api，直接调用的方式
     */

  }, {
    key: "invoke",
    value: function invoke() {
      return _invoke.apply(this, arguments);
    }
    /**
     * 判断当前客户端版本是否支持指定 JS 接口
     * @param {Array} apiList - 接口列表
     * @returns {Promise}
     * @example <caption>Check availability of api `actionLogin` in iPad.</caption>
     * atom.checkApi(['actionLogin']).then(function(res) {
     *     console.log(JSON.stringify(res))
     * })
     */

  }, {
    key: "checkApi",
    value: function checkApi() {
      var apiList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (!env.isApp) {
        var res = {};

        for (var i = 0; i < apiList.length; i++) {
          res[apiList[i]] = false;
        }

        return Promise.resolve(res);
      }

      return _invoke('checkApi', {
        apiList: apiList
      });
    }
    /**
     * 关闭 Webview 窗口
     * @returns {Promise}
     * @example
     * atom.close()
     */

  }, {
    key: "close",
    value: function close() {
      if (!env.isApp) {
        return window.close();
      }

      return _invoke('close');
    }
    /**
     * 拉起双登录，或者单点登录
     * @param {string} type - tv: 双登录/wx: 微信/qq: QQ
     * @returns {Promise}
     * @example
     * atom.openLogin()
     */

  }, {
    key: "openLogin",
    value: function openLogin() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'tv';
      return _invoke('actionLogin', {
        type: type
      });
    }
    /**
     * 打开新的 webview，匹配到内部协议时，将会以 openView 打开
     * 1. 在 HollywoodH5Activity webview 中打开时，是以浮层形式打开
     * 2. 在 Html5Activity webview 中打开时，是以全屏形式打开，有返回按钮
     * 3. 在 PopHollywoodH5Activity webview 中打开时，是以全屏形式打开，有返回按钮
     * @param {String} url - 页面地址
     * @param {Object} options - App 环境下，可指定 close:1/0，是否关闭当前页面
     * @returns {Promise}
     * @example
     * atom.openUrl('//film.qq.com')
     */

  }, {
    key: "openUrl",
    value: function openUrl() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var protocol = location.protocol.match(/^https?:/) ? location.protocol : 'https:';

      if (url.match(/^\/\//)) {
        // 补全地址
        url = protocol + url;
      }

      if (!env.isApp) {
        location.href = url;
        return Promise.resolve(null);
      } else {
        if (url.match(/^(txvideo|tenvideo2)/)) {
          return this.openView(url);
        } else {
          if (!options) options = {};
          options.url = url;
          return _invoke('openUrl', options);
        }
      }
    }
    /**
     * native 页面跳转操作
     * @param {string} url - txvideo://v.qq.com/ 协议地址
     * @example <caption>phone 示例</caption>
     * atom.openView('txvideo://v.qq.com/HomeActivity?tabName=VipTab&channelId=100203')
     */

  }, {
    key: "openView",
    value: function openView() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return _invoke('openView', {
        url: url
      });
    }
    /**
     * 获取用户信息
     * @param {string} useCGI - iframe 场景无法通过 JSAPI 获取用户信息
     * @returns {Promise}
     * @example
     * atom.getMainUserInfo().then(function(res) {
     *     console.log('userInfo', res)
     * })
     */

  }, {
    key: "getMainUserInfo",
    value: function getMainUserInfo() {
      var useCGI = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (useCGI) {
        return _getMainUserInfo();
      } else {
        return new Promise(function (resolve) {
          _invoke('getMainUserInfo').then(function (res) {
            if (res && res.userInfo) {
              resolve({
                headurl: res.userInfo.headImgUrl,
                nick: res.userInfo.nickname,
                type: res.type,
                id: res.type === 'wx' ? res.userInfo.openId : res.userInfo.uin
              });
            } else {
              resolve(null);
            }
          }).catch(function (e) {
            // 未登录
            resolve(null);
          });
        });
      }
    }
    /**
     * 获取 App 信息
     * @returns {Promise}
     * @example
     * atom.getAppInfo().then(function(res) {
     *     console.log('appInfo', res)
     * })
     */

  }, {
    key: "getAppInfo",
    value: function getAppInfo() {
      if (!env.isApp) {
        return Promise.resolve({
          'isJBOS': 0,
          'buildVersion': '',
          'supportiap': false,
          'isinreview': false,
          'deviceType': env.device,
          'version': '',
          'pkgName': 'h5',
          'systemVersion': '',
          'installTime': '0',
          'screenResolution': "".concat(window.screen.availWidth, "*").concat(window.screen.availHeight)
        });
      }

      return _invoke('getAppInfo');
    }
    /**
     * 获取设备信息
     * @returns {Promise}
     * @example
     * atom.getDeviceInfo().then(function(res) {
     *     console.log('deviceInfo', res)
     * })
     */

  }, {
    key: "getDeviceInfo",
    value: function getDeviceInfo() {
      if (!env.isApp || env.isWin) {
        return Promise.resolve({
          'guid': cookie.get('video_guid') || cookie.get('guid'),
          'isJBOS': 0,
          'deviceId': ''
        });
      }

      return _invoke('getDeviceInfo');
    }
    /**
     * 获取 cookie 数据，登录态相关
     * @param {string} useDocument - 直接取 document.cookie，在 iframe 场景下无法获取 cookie
     * @returns {Promise}
     * @example
     * atom.getMainCookie().then(function(res) {
     *     console.log('cookie', res)
     * })
     */

  }, {
    key: "getMainCookie",
    value: function getMainCookie() {
      var useDocument = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!env.isApp || env.isWin || useDocument) {
        // 浏览器环境下，直接取 document.cookie
        return Promise.resolve(parse(document.cookie));
      } else {
        return new Promise(function (resolve) {
          var api = env.isLiteApp ? 'getCookie' : 'getMainCookie';

          _invoke(api).then(function (res) {
            if (!res) resolve(null);
            var cookies = parse(res.cookie);
            cookies.main_login = res.type;
            resolve(cookies);
          }).catch(function (e) {
            resolve(null);
          });
        });
      }
    }
    /**
     * 获取指定账号类型的 Cookie
     * @param {string} loginType - 账号类型，qq/wx
     * @returns {Promise}
     * @example
     * atom.getCookie().then(function(res) {
     *     console.log('cookie', res)
     * })
     */

  }, {
    key: "getCookie",
    value: function getCookie() {
      var loginType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'qq';

      if (!env.isApp) {
        // 浏览器环境下，直接取 document.cookie
        return Promise.resolve(parse(document.cookie));
      }

      return _invoke('getCookie', {
        type: [loginType]
      }).then(function (res) {
        if (!res || !res[loginType]) return null;
        var cookies = parse(res[loginType]);
        cookies.main_login = loginType;
        return cookies;
      });
    }
    /**
     * 获取 PayVip 数据
     * @param {string} useCGI - 强制走 CGI 接口，兼容 iphone 的接口在切换登录态后无法获取新的会员信息的问题
     * @returns {Promise}
     * @example
     * atom.getPayVip().then(function(res) {
     *     console.log('vipInfo', res)
     * })
     */

  }, {
    key: "getPayVip",
    value: function getPayVip() {
      var useCGI = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (Object.prototype.toString.call(useCGI) === '[object Object]') {
        param = useCGI;
        useCGI = true;
      }

      if (useCGI || !env.isApp) {
        // 浏览器
        return _getPayVip(param).catch(function (e) {
          console.error(e);
          return null;
        });
      } else {
        return _invoke('getPayVip').then(function (data) {
          if (Object.keys(data).length === 0) {
            return null;
          }

          return data;
        });
      }
    }
    /**
     * 刷新会员数据
     * @desc 即 payVip 数据，主要在一些情况下，如游客会员转移需要手动触发客户端更新会员数据。
     * @returns {Promise}
     * @example
     * atom.refreshVipInfo()
     */

  }, {
    key: "refreshVipInfo",
    value: function refreshVipInfo() {
      return _invoke('refreshVipInfo');
    }
    /**
     * 播放影片
     * @param {String} cid - 专辑id
     * @param {String} vid - 影片id
     * @param {Object} options - 用于H5播放页拼接链接参数
     * @returns {Promise}
     * @example
     * atom.play({ cid: 'ez00dy0uu12rc4j', vid: 'f0031z13osc' })
     */

  }, {
    key: "play",
    value: function play() {
      var cid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var vid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var param = {
        cid: cid,
        vid: vid
      };

      if (Object.prototype.toString.call(vid) === '[object Object]') {
        options = vid;
        param.vid = '';
      }

      if (Object.prototype.toString.call(cid) === '[object Object]' && (cid.cid || cid.vid)) {
        param = cid;
      }

      assign(param, options);
      var videoUrl = buildUrl("https://m.v.qq.com/x/play.html", param, true);

      if (env.isApp) {
        switch (env.device) {
          case 'ipad':
          case 'iphone':
          case 'aphone':
            return this.openView(buildUrl('tenvideo2://?action=1', {
              cover_id: param.cid,
              video_id: param.vid
            }));

          case 'windows':
            return Tenvideoatom.OpenQQLive("qqlive://sso/cid=".concat(param.cid, "&vid=").concat(param.vid));

          default:
            location.href = videoUrl;
        }
      } else {
        location.href = videoUrl;
      }

      return Promise.resolve(null);
    }
    /**
     * Native 的弱提示浮层
     * @param {String} content - 提示内容
     * @param {Object} options - { duration: 3000, native: true }
     * @returns {Promise} null
     * @example
     * atom.toast('hello, world!')
     */

  }, {
    key: "toast",
    value: function toast() {
      var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        duration: 3000,
        native: true
      };

      if (!env.isApp || env.isMac || env.isWin || !options.native) {
        _toast(content, options.duration);

        return Promise.resolve(null);
      }

      return this.checkApi(['toast']).then(function (api) {
        _invoke('toast', {
          content: content
        });
      }).catch(function (e) {
        _toast(content, options.duration);
      });
    }
    /**
     * 写日志到客户端
     * @param {String} content - 日志内容
     * @returns {Promise}
     */

  }, {
    key: "log",
    value: function log() {
      var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (env.isApp) {
        return _invoke('writeLog', {
          content: content
        });
      } else {
        console && console.log(content);
      }
    }
    /**
     * 显示 loading
     * @param {String} text - 加载标题
     * @param {String} options - 参数配置, { timeout: 3000, close: true }
     * @returns {Promise}
     */

  }, {
    key: "showLoading",
    value: function showLoading() {
      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new Loading(text, options);
    }
    /**
     * 隐藏所有 loading 浮层
     * 推荐使用以下方法关闭 loading
     * @example
     * let loading = atom.showLoading();
     * loading.hide()
     */

  }, {
    key: "hideLoading",
    value: function hideLoading() {
      _hideLoading();
    }
    /**
     * 获取 APP 版本号
     * @returns {Version}
     */

  }, {
    key: "getVersion",
    value: function getVersion() {
      return _getVersion();
    }
    /**
     * 获取商品打折信息
     * @param {Array} productIds
     * @param {Object} options
     * @param {Boolean} [options.fromApple] 从苹果获取折扣信息
     * @returns {Promise}
     */

  }, {
    key: "getDiscountInfo",
    value: function getDiscountInfo(productIds, offerid) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _options$fromApple = options.fromApple,
          fromApple = _options$fromApple === void 0 ? true : _options$fromApple;
      return new Promise(function (resolve, reject) {
        var checkCallback = false;

        _invoke('getProductIDSDiscountInfo', {
          productids: productIds,
          offerid: offerid,
          fromapple: fromApple
        }).then(function (res) {
          checkCallback = true;
          resolve(res);
        }).catch(function (e) {
          checkCallback = true;
          reject(e);
        }); // 坑！！！
        // 这里有时会出现调用 jsapi 后，没有 callback，导致楼下在 await getDiscountInfo 时，出现挂起现象


        var timer = setTimeout(function () {
          if (!checkCallback) {
            reject({
              msg: 'jsapi 超时无返回'
            });
          } else {
            clearTimeout(timer);
          }
        }, 10000);
      });
    }
    /**
     * 检查是否有资格参与商品折扣活动
     * @param {String | Array} productId
     * @param {String} offerid
     * @param {Object} options
     * @param {Boolean} [options.fromApple]
     * @param {Number} [options.limitTimes] 限制次数
     * @param {Boolean} [options.onlyApple] 仅限制苹果id
     * @returns {Promise}
     */

  }, {
    key: "checkDiscount",
    value: function checkDiscount(productId, offerid) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _options$limitTimes = options.limitTimes,
          limitTimes = _options$limitTimes === void 0 ? 1 : _options$limitTimes,
          _options$fromApple2 = options.fromApple,
          fromApple = _options$fromApple2 === void 0 ? true : _options$fromApple2,
          _options$onlyApple = options.onlyApple,
          onlyApple = _options$onlyApple === void 0 ? true : _options$onlyApple;
      return this.getDiscountInfo(Array.isArray(productId) ? productId : [productId], offerid, fromApple).then(function () {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            ret = _ref.ret,
            only_local = _ref.only_local,
            eligibility_info = _ref.eligibility_info;

        if (ret !== 0 || !Array.isArray(eligibility_info) || !eligibility_info.length) {
          return true;
        }

        return eligibility_info.map(function (info) {
          // eslint-disable-next-line
          var num = info.num,
              apple_num = info.apple_num,
              apple_num_total = info.apple_num_total; // eslint-disable-next-line

          if (only_local == 1 && num < limitTimes) {
            return true;
          } // eslint-disable-next-line


          if (+only_local === 0 && apple_num < limitTimes && apple_num_total < limitTimes) {
            return onlyApple ? true : num < limitTimes;
          }

          return false;
        }).indexOf(false) === -1;
      }).catch(function () {
        return true;
      });
    }
  }]);

  return Protocol;
}();

export { Protocol as default };